// Shared by the prerenderer, sitemap and client-side navigation.
export const PUBLIC_PAGES = [
  {
    path: '/',
    title:
      'sortmyprep - AI-Powered Exam Prep for IGCSE, AS & A Level, and IBDP',
    description:
      'Prepare for IGCSE, AS & A Level and IBDP exams with past papers, topic-wise practice, step-by-step solutions and the Sorty AI tutor.',
    changefreq: 'weekly',
    priority: '1.0',
  },
  {
    path: '/auth/login',
    title: 'SortMyPrep Login - Sign in to your account',
    description:
      'Log in to your SortMyPrep account to access past papers, topic-wise practice, mock exams and your study progress for IGCSE, AS & A Level and IBDP.',
    changefreq: 'monthly',
    priority: '0.6',
  },
  {
    path: '/teachers',
    title: 'Tools for Teachers - sortmyprep',
    description:
      'Explore sortmyprep tools for teachers, including worksheet creation and exam preparation resources for international-board students.',
    changefreq: 'monthly',
    priority: '0.7',
  },
  {
    path: '/our-partners',
    title: 'Our Education Partners - sortmyprep',
    description:
      'Meet the counsellors and tutors in the sortmyprep partner network, offering academic guidance, exam preparation and university admissions support.',
    changefreq: 'monthly',
    priority: '0.6',
  },
  {
    path: '/blogs',
    title: 'Blogs - study advice for IGCSE, A Level and IBDP',
    description:
      'Practical, evidence-based advice on revision, exam prep, and learning - written to help you get the most from every hour you study.',
    changefreq: 'weekly',
    priority: '0.7',
  },
  {
    path: '/webinars',
    title: 'Free Webinars for Teachers - sortmyprep',
    description:
      'Register for free sortmyprep webinars for IGCSE, AS & A Level and IBDP teachers, and learn how AI can cut your prep and marking time.',
    changefreq: 'weekly',
    priority: '0.6',
  },
  {
    path: '/terms-of-service',
    title: 'Terms of Service - sortmyprep',
    description:
      'Read the terms governing the use of sortmyprep, including accounts, subscriptions, educational content and platform services.',
    changefreq: 'yearly',
    priority: '0.3',
  },
  {
    path: '/privacy-policy',
    title: 'Privacy Policy - sortmyprep',
    description:
      'Learn how sortmyprep collects, uses and protects personal information, and how to exercise your privacy rights.',
    changefreq: 'yearly',
    priority: '0.3',
  },
  {
    path: '/cookie-policy',
    title: 'Cookie Policy - sortmyprep',
    description:
      'Learn how sortmyprep uses cookies and similar technologies, and how to manage your cookie preferences.',
    changefreq: 'yearly',
    priority: '0.3',
  },
];
